module.exports = "<div [id]=\"id\" class=\"igo-map-browser-target\"></div>\r\n<ng-content></ng-content>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/map/map-browser/map-browser.component.html
// module id = 887
// module chunks = 0